import { Repository } from '../../../core/context/repository';
import { type ThreatVectorComment } from './entity';

export class ThreatVectorComments extends Repository<ThreatVectorComment> {
    getByThreatVectorId(threatVectorId: string): ThreatVectorComment[] {
        return this.items.filter(
            (entity) => entity.threatVectorId === threatVectorId,
        );
    }
}
